export default __webpack_public_path__ + "static/media/react_logo.f153eb9f.png";